import {
  Operator,
} from '../../../../../../../../services/common/Constants';
import React from 'react';
import EqualValue from './EqualValue';
import ComparisonValue from './ComparisonValue';
import SetValue from './SetValue';

const Numeric = ({
  selectedFieldSubType,
  selectedOperator,
  availableValueOptions,
  fieldName,
  showLabel,
  readOnly = false
}) => {
  switch (selectedOperator) {
    case Operator.EQUAL:
    case Operator.NOT_EQUAL:
      return (
        <EqualValue
          availableValueOptions={availableValueOptions}
          fieldName={fieldName}
          showLabel={showLabel}
          selectedFieldSubType={selectedFieldSubType}
          readOnly={readOnly}
        />
      );
    case Operator.GREATER_THAN:
    case Operator.GREATER_OR_EQUAL:
    case Operator.LESS_THAN:
    case Operator.LESS_OR_EQUAL:
      return (
        <ComparisonValue
          availableValueOptions={availableValueOptions}
          fieldName={fieldName}
          showLabel={showLabel}
          selectedFieldSubType={selectedFieldSubType}
          readOnly={readOnly}
        />
      );

    case Operator.BETWEEN:
      return <>{/*TODO: Two values*/}</>;

    case Operator.IS_NULL:
    case Operator.NOT_NULL:
      return <>{/*MEANS ATTRIBUTE IS UNDEFINED*/}</>;

    case Operator.IN_SET:
    case Operator.NOT_IN_SET:
      return (
        <SetValue
          availableValueOptions={availableValueOptions}
          fieldName={fieldName}
          showLabel={showLabel}
          readOnly={readOnly}
        />
      );

    default:
      return <></>;
  }
};

export default Numeric;
